import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["NextIntlProvider"] */ "/vercel/path0/src/components/providers/nextintl-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ParallaxProvider"] */ "/vercel/path0/src/components/providers/parallax-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextThemesProvider"] */ "/vercel/path0/src/components/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/sonner.tsx");
